var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#276E65"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2034_9721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3332 45V41.6667C38.3332 39.8986 37.6308 38.2029 36.3805 36.9526C35.1303 35.7024 33.4346 35 31.6665 35H18.3332C16.5651 35 14.8694 35.7024 13.6191 36.9526C12.3689 38.2029 11.6665 39.8986 11.6665 41.6667V45M48.3332 45V41.6667C48.3321 40.1895 47.8404 38.7546 46.9354 37.5872C46.0305 36.4198 44.7634 35.5859 43.3332 35.2167M36.6665 15.2167C38.1005 15.5838 39.3716 16.4178 40.2792 17.5872C41.1869 18.7565 41.6796 20.1947 41.6796 21.675C41.6796 23.1553 41.1869 24.5935 40.2792 25.7628C39.3716 26.9322 38.1005 27.7662 36.6665 28.1333M31.6665 21.6667C31.6665 25.3486 28.6817 28.3333 24.9998 28.3333C21.3179 28.3333 18.3332 25.3486 18.3332 21.6667C18.3332 17.9848 21.3179 15 24.9998 15C28.6817 15 31.6665 17.9848 31.6665 21.6667Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2034_9721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamFrame);
export default __webpack_public_path__ + "static/media/team-frame.20dc542d7cc37cf7e8bb4e9f7a81baef.svg";
export { ForwardRef as ReactComponent };